<template>
  <div class="fis-stake">
    <div class="left">
      <div class="menus">
        <div class="menu">
          <div class="title" :class="{'active': userActive === 'staker'}" @click="selectElement('staker')">
            Staker
          </div>
          <template v-if="userActive === 'staker'">
            <div class="validator-items">
              <div class="validator-item" :class="{'validator-active': stakerActive === 'stakerStatus'}" 
                @click="selectStakerElement('stakerStatus')">
                -Status
              </div>
            </div>
          </template>
        </div>
        <div class="menu">
          <div class="title" :class="{'active': userActive === 'validator'}" @click="selectElement('validator')">
            Validator
          </div>
        </div>
        
      </div>
    </div>

    <div class="right">
      <template v-if="userActive === 'staker'">
        <component
          :is="stakerComponent"
          @stake="stake"
          @stakeSuccess="stakeSuccess"
          @stakerHandleSuccess="stakerHandleSuccess" />
      </template>

      <template v-if="userActive === 'validator'">
        <component
          :is="validatorComponent"
          :pool-info="poolInfo"
          @onboardSuccess="onboardSuccess"
          @offboardSuccess="offboardSuccess" />
      </template>

    </div>
    
  </div>
</template>

<script>
import { setTimeout } from 'timers';
import rpc from '../util/rpc.js';
import { Toast } from 'mint-ui';
import Web3Util from '../util/web3Util.js';
import StakerUnstaked from '../components/rfis/StakerUnstaked';
import StakerStaked from '../components/rfis/StakerStaked';
import ValidatorProcess from '../components/rfis/ValidatorProcess';
import ValidatorStatus from '../components/rfis/ValidatorStatus';
import Api from '../util/SubstrateApi.js';
import LocalStorage from '../util/localStorage.js';

const stakerUserActive = 'staker';

export default {
  name: 'rfis',
  components: {
    StakerUnstaked,
    StakerStaked,
    ValidatorProcess,
    ValidatorStatus
  },
  data() {
    return {
      userActive: stakerUserActive,
      stakerActive: '',
      stakerComponent: 'StakerUnstaked',
      validatorComponent: 'ValidatorProcess',
      rethData: {},
      poolInfo: {}
    }
  },
  methods: {
    selectElement(name) {
      this.userActive = name;
      if (name == 'staker') {
        this.stake();
      } else {
        let currentAddress = LocalStorage.getCurrentFisAccount();
        Api.createStafiApi().then(api => {
          api.query.rFis.onboardValidators().then(result => {

            let validators = result.toJSON();
            if (validators && validators.length > 0) {
              api.query.staking.ledger(currentAddress).then(ledgerData => {
                let ledger = ledgerData.toJSON();
                if (ledger) {
                    if (validators.indexOf(ledger.stash) != -1) {
                      this.showValidatorStatus();
                    }
                }
              }).catch((error) => {});
            }

            
          }).catch((error) => {});
        })
        .catch((error) => {});
      }
    },
    selectStakerElement(name) {
      this.userActive = stakerUserActive;
      if (name == 'stakerStatus') {
        this.stakerActive = 'stakerStatus';
        this.stakerComponent = 'StakerStaked';
      }
    },
    onboardSuccess() {
      this.showValidatorStatus();
      this.$emit('refreshFisBalance');
    },
    offboardSuccess() {
      this.showValidatorProcess();
      this.$emit('refreshFisBalance');
    },
    showValidatorProcess() {
      this.userActive = 'validator';
      this.validatorComponent = 'ValidatorProcess';
    },
    showValidatorStatus() {
      this.userActive = 'validator';
      this.validatorComponent = 'ValidatorStatus';
    },
    checkStakerStatus(address) {
      if (address) {
        if (!(this.userActive == stakerUserActive && this.stakerComponent == 'StakerUnstaked')) {
          this.stake();
        }
      }
    },
    stake() {
      this.userActive = stakerUserActive;
      this.stakerActive = '';
      this.stakerComponent = 'StakerUnstaked';
    },
    stakeSuccess() {
      this.selectStakerElement('stakerStatus');
      this.$emit('refreshFisBalance');
    },
    stakerHandleSuccess() {
      this.$emit('refreshFisBalance');
    }
  },
  created() {
    if (this.$route.params && this.$route.params.source) {
      if (this.$route.params.source == 'redeem') {
        this.selectStakerElement('stakerStatus');
        return;
      }
    }

    let currentAddress = LocalStorage.getCurrentFisAccount();
    Api.createStafiApi().then(api => {
      api.query.rFis.onboardValidators().then(result => {
        let validators = result.toJSON();
        if (validators && validators.length > 0) {
          api.query.staking.ledger(currentAddress).then(ledgerData => {
            let ledger = ledgerData.toJSON();
            if (ledger) {
                if (validators.indexOf(ledger.stash) != -1) {
                  this.showValidatorStatus();
                }
            }
          }).catch((error) => {});
        }
      }).catch((error) => {});

      api.query.rBalances.account(0, currentAddress).then(accountData => {
        let data = accountData.toJSON();
        if (data && data.free > 0) {
          this.selectStakerElement('stakerStatus');
        }
      });

    })
    .catch((error) => {});
  }
}
</script>

<style lang="scss">
@import "../mixin.scss";

.fis-stake {
  background-color: #2B3239;
  width: 683px;
  padding-bottom: 50px;
  border-radius: 19px;

  display: flex;

  .left {
    margin-left: 32px;
    margin-top: 11px;
    padding-right: 20px;
    padding-top: 21px;
    border-right: 1px solid #474747;

    .menus {
      .menu {
        cursor: pointer;
        margin-bottom: 33px;
        .title {
          font-size: 14px;
          font-weight: bold;
          text-align:right;
        }

        .active {
          color: #00F3AB;
        }

        .validator-items {
          text-align:right;
          .validator-item {
            font-size: 12px;
            font-weight: normal;
            margin-top: 5px;
            color: #fff;
          }

          .validator-active {
            color: #00F3AB;
          }
        }

      }
    }
  }

  .right {
    margin-left: 46px;
    padding-right: 20px;

    .title {
      font-size: 30px;
      font-weight: bold;
      margin-top: 36px;
    }

    .inputs {
      margin-top: 60px;
      width: 442px;
      height: 50px;
      border-radius: 3.65px;
      border: 1px solid #BFBFBF;
      padding-left: 25px;
      position: relative;
      
      .icon {
        height: 36px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 10px;
        img {
          height: 100%;
        }
      }
      input {
        font-size: 22px;
        font-weight: bold;
        width: 390px;
        height: 48px;
        background-color: #2B3239;
        border: 0;
        color: #fff;

        &:focus {
          outline: none
        }
      }
    }

    .desc {
      color: #C4C4C4;
      font-size: 16px;
      margin-top: 30px;
      .pool {
        cursor: pointer;
        color: #00F3AB;
        text-decoration: underline;
      }
    }

    .items {
      margin-top: 60px;
      .item {
        margin-bottom: 32px;

        .item-title {
          font-size: 16px;
        }

        .item-value {
          font-size: 30px;
          color: #00F3AB;
          font-weight: bold;
        }
      }
    }
    
  }

}
</style>
